import React from 'react'
import { ReactSVG } from 'react-svg'

interface InfoCardProps {
  align?: 'center' | 'top' | 'bottom'
  icon?: string
  iconDescription?: string
  children?: React.ReactNode
}

const InfoCard: React.FC<InfoCardProps> = ({ icon, iconDescription = '', children, align = 'center' }) => {
  const alignClass = align === 'center' ? 'justify-center' : align === 'top' ? 'justify-start' : 'justify-end'
  return (
    <article className={`w-full md:max-w-[284px] gap-5 p-8 md:py-9 md:px-10 bg-[var(--info-card-bg)] text-[var(--info-card-text)] text-sm rounded-lg flex md:flex-col ${alignClass} items-center`}>
      { icon &&
        <div className='shrink-0 size-12 md:size-[108px] flex items-center justify-center md:mx-auto text-[var(--theme-icon)]'>
          <ReactSVG className='InfoCard-svg size-full flex items-center justify-center' src={icon} aria-label={iconDescription}/>
        </div>
      }
      { children &&
      <div className={`text-lg/6 md:text-center max-md:grow _simple-rte ${align === 'top' ? 'grow' : '' } `}>
        {children}
      </div>
    }
    </article>
  )
}

export {InfoCard}